import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {CloudProvisionerResponse} from '~/models/Commons ';
import { RootState } from '~/store/index';

interface State {
    provisioner: CloudProvisionerResponse[];
     authenticated: boolean;
}

const initialState: State = {
    provisioner: [],
    authenticated:false
};

const CloudProvisionerSlice = createSlice({
    name: 'provisioner',
    initialState,
    reducers: {
        SET_CLOUDPROVISIONER(state, { payload }: PayloadAction<CloudProvisionerResponse[]>) {
            state.provisioner = payload;
        },
            DELETE_CLOUDPROVISIONER_BYID(state, { payload }: PayloadAction<number>) {
            if (!Array.isArray(state.provisioner)) {
                state.provisioner = [];
            }

            state.provisioner = state.provisioner.map(item =>
                item.id !== payload ? item : { ...item, active: false }
            );
        },

        ADD_CLOUDPROVISIONER(state, { payload }: PayloadAction<CloudProvisionerResponse>) {
            const newScripts = [...state.provisioner, payload];
            state.provisioner = newScripts;
        },
        PATCH_CLOUDPROVISIONER(state, { payload }: PayloadAction<CloudProvisionerResponse>) {
            const newCloudEnvironment = [...state.provisioner];
            const findInd = newCloudEnvironment.findIndex(({ id }) => id === payload.id);
            if (findInd < 0) return;

            newCloudEnvironment[findInd] = { ...payload };
            state.provisioner = newCloudEnvironment;
        },
         SET_AUTHENTICATED(state, { payload }: PayloadAction<boolean>) {
            state.authenticated = payload;
        },
    },
});

export const selectCloudProvisioner = (state: RootState) => state.provider;

export const { SET_CLOUDPROVISIONER, DELETE_CLOUDPROVISIONER_BYID, ADD_CLOUDPROVISIONER, PATCH_CLOUDPROVISIONER,SET_AUTHENTICATED } =
    CloudProvisionerSlice.actions;

export default CloudProvisionerSlice.reducer;
